import React from "react";
import { Control, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { HotelFormData } from "../utils/hotelSchema";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { CurrencyRow } from "../../billing-settings/components/CurrencyRow";

interface BillingSettingsFormProps {
  control: Control<HotelFormData>;
}

const BillingSettingsForm: React.FC<BillingSettingsFormProps> = ({
  control,
}) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-6 border-t pt-6 mt-6">
      <h3 className="text-lg font-medium">
        {t("hotels.form.billingSettings")}
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="flex items-center justify-between space-x-2 border p-3 rounded-md">
          <Label
            htmlFor="paymentSettings.paymentEnabled"
            className="flex flex-col space-y-1"
          >
            <span>{t("hotels.form.enablePayment")}</span>
            <span className="font-normal text-xs text-muted-foreground">
              {t("hotels.form.enablePaymentDescription")}
            </span>
          </Label>
          <Controller
            name="paymentSettings.paymentEnabled"
            control={control}
            render={({ field }) => (
              <Switch
                id="paymentSettings.paymentEnabled"
                checked={field.value}
                onCheckedChange={field.onChange}
              />
            )}
          />
        </div>

        <div className="flex items-center">
          <Controller
            name="paymentSettings.currency"
            control={control}
            render={({ field }) => (
              <CurrencyRow value={field.value} onChange={field.onChange} />
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default BillingSettingsForm;
